// extracted by mini-css-extract-plugin
module.exports = {"cards":"BigArchiveCards_cards__J31HU","wrap":"BigArchiveCards_wrap__hU51V"};